import { Injectable } from '@angular/core';

import {Backend} from "../backend/backend";
import {EntityFile, PartnerAvatarFile} from "./entity-file";

/**
 * Url generator service.
 * Generates a real URL from file's identifier and mutation.
 */
@Injectable({ providedIn: 'root' })
export class UrlGeneratorEntityImageService {

  constructor(private backend: Backend) {
  }

  /**
   * Generates a file's URL.
   *
   * `file.mutation` can be extended by `mutation`.
   */
  generateUrl = (file: EntityFile): string => {
    if (file == null || file.identifier == null) return;
    if (file instanceof PartnerAvatarFile)  {
      return this.backend.partners.getPartnerLogoPath(Number(file.identifier));
    }

    throw Error(`Unable to generate URL: ${file.identifier} for this type of file: ${file.constructor.name}`);
  };
}
